import type { Approver } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApproversService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getApprovers = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, Approver[]>({
      method: 'GET',
      url: '/api/app/approvers/approvers',
    },
    { apiName: this.apiName,...config });
}